import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {getCompany} from "../index";
import {BASE_URL} from "../Landing/Components/Api/Api";


export const getProvince = createAsyncThunk('get-province', async () => {
    try{

    const response = await axios.post(BASE_URL, {}, {
        headers: {
            "Content-type": "multipart/form-data",
            'Accept': 'application/json',
            'cmd': 'province'
        },
    });
    if (response.status === 200) {
        const data = await response.data
        // console.log(data?.dt,'data of login response')
        return data?.dt
    } else {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    }catch (error){
        throw error;
    }
});



const initialState = {
    province: [],
    loading: false,
    error: null,
};

export const ProvinceSlice = createSlice({
    name: "province",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getProvince.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProvince.fulfilled, (state, action) => {
                state.loading = false;
                state.province = action.payload;
            })
            .addCase(getProvince.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});


export default ProvinceSlice.reducer;